import React, { createContext, useState } from 'react';
import ClientLayout from '../../layouts/ClientLayout';
import BreadcrumbsShared from '../../components/Shared/BreadcrumbsShared';
import { GENERAL_ROUTE } from '../../routes/const';
import useReload from '../../hooks/useReload';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showSuccessSnackbar } from '../../redux/actions/userActions';
import moment from 'moment';
import 'moment/locale/ru';
import ClientHistoryCRUDTable from '../../components/Crud/Tables/ClientHistoryCRUDTable';

moment.locale('ru');

export const HistoryContext = createContext();

const HistoryRequests = () => {
  const { reload, reloadValue } = useReload();
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState({});

  // 🔹 обработчик для экспорта (если добавишь позже)
  const handleHistoryToExcel = async (filter) => {
    try {
      dispatch(showSuccessSnackbar('Экспорт истории заявок временно недоступен', 'info'));
    } catch (e) {
      dispatch(showSuccessSnackbar('Ошибка при экспорте', 'error'));
      console.error(e);
    }
  };

  return (
    <ClientLayout>
      <BreadcrumbsShared
        breadcrumbs={[
          { text: 'Главная', link: GENERAL_ROUTE + '/' },
          { text: 'История заявок', link: GENERAL_ROUTE + '/history' },
        ]}
      />

      <HistoryContext.Provider
        value={{
          handleHistoryToExcel,
          page,
          setPage,
          rowsPerPage,
          setRowsPerPage,
          filter,
          setFilter,
        }}
      >
        <ClientHistoryCRUDTable
          type="standart"
          onClickDetailsButton={(id) => history.push(GENERAL_ROUTE + `/history/${id}`)}
          reloadValue={reloadValue}
          modalFilter
        />
      </HistoryContext.Provider>
    </ClientLayout>
  );
};

export default HistoryRequests;
